/**
 * Messages for yup validation
 */

const messages = {
  formValidations: {
    invalidName: 'Please provide a valid name',
    invalidDate: 'Please provide a valid date: YYYY-MM-DD',
    invalidAdultBirthday: 'Please provide a valid adult birthday.',
    invalidTime: 'Please provide a valid time: 00:00 to 23:59',
    invalidSsn: 'Please provide a valid SSN or TIN: 123-45-6789',
    invalidPhone: 'Please provide a valid phone number: 234-567-8901',
    invalidEmail: 'Please provide a valid email address',
    invalidFeid: 'Please provide a valid FEID #: 12-3456789',
    invalidDuns: 'Please provide a valid DUNS #: 123456789',
    invalidZipCode: 'Please provide a valid Zip Code / Postal Code',
    invalidNumberOfBeds:
      'Please provide a valid number of beds: Value must be between 0 and 9.',
    invalidNumberInteger: 'Please provide a valid integer number.',

    invalidStringLength: (min, max) => {
      if (min && max) {
        return `Must be between ${min} and ${max} characters.`;
      }
      return min
        ? `Must be ${min} or more characters.`
        : `Must be ${max} or less characters`;
    },
    dateShouldBeInThePast: 'Date should be in the past.',
    needChoice: 'Please choose one',
    needValue: 'Required',
    needExplain: 'Please explain',
    needEmailConfirm: 'Please confirm your email address',
    needEmailMatch: 'Email addresses do not match',
    needPasswordLength: 'Password must be at least 4 characters long',
    needPasswordLowercase: 'Password must contain at least 1 lowercase letter',
    needPasswordUppercase: 'Password must contain at least 1 uppercase letter',
    needPasswordNumber: 'Password must contain at least 1 number',
    needPasswordConfirm: 'Please confirm your password',
    needPasswordMatch: 'Passwords do not match',
    needCredentials:
      'Please provide either: Driver License/State ID, Social Security Number or TIN, Passport, or Alien Registration',
    needIdOrigin: 'Required when providing Driver License/State ID',
    needPassportCountry: 'Required when providing Passport #',
    needAdultInfo:
      'Please provide all required information for adult(s) or choose "No"',
    needMinorInfo:
      'Please provide all required information for minor(s) or choose "No"',
    needPositiveValue: 'Please provide a value greater than 0',
    needZeroOrGreater: 'Please provide a value 0 or greater',
    needStartDate: 'Required when providing End Date',
    needEndDate: 'End Date must be after Start Date',
    needFromDate: 'From Date must be on or before To Date',
    needStartTime: 'Start time must be on or before end time',
    needValueOrIncome: 'Please provide either: Value or Monthly Income',
    needIssue:
      'Please choose a description of the issue from below or provide your own',
    needLocation:
      'Please choose a common area location from below or provide your own',
    needUniqueAccountNumber:
      'Account is already saved as a valid payment method. Please enter a new account number',
    requiredMessage: 'This field is required',
    needAcceptTos: 'Must Accept Terms and Conditions',
    needAccountNumberMatch:
      'The values in Account Number and Re-enter Account Number do not match. Please verify.',
    invalidRoutingNumberFormat: 'Only numeric values 0-9 allowed',
    invalidRoutingNumber: 'Invalid Routing Number',
    ca: {
      invalidInstitutionNumber: 'Institution number must have 3 numbers',
      invalidTransitNumber: 'Transit number must have 5 numbers',
      invalidAccountNumber: 'Account number must have from 5 to 12 numbers',
    },
  },
};

export default messages;
